export default __webpack_public_path__ + "static/media/quantco_Q_black.1794038b.png";